/**
 * The `?next=` param carries the page the guard sent the user from. It is
 * untrusted input — only same-app paths are honoured, so a forged query can
 * never become an open redirect after sign-in.
 */
export function sanitizeNext(value: string | null): string {
  if (!value) return '/';
  if (!value.startsWith('/') || value.startsWith('//')) return '/';
  return value;
}
